module.exports = {
    "xspace.client.xform.XImage.xeditorUploadImageImage": "تحميل الصور",
    "xspace.client.xform.XImage.xeditorXImageAlign": "محاذاة",
    "xspace.client.xform.XImage.xeditorXImageDeleteImage": "حذف الصور",
    "xspace.client.xform.XImage.xeditorXImageDownloadImage": "تحميل الصور",
    "xspace.client.xform.XImage.xeditorXImageImage": "الصور",
    "xspace.client.xform.XImage.xeditorXImageLeftAlign": "تعويم إلى اليسار",
    "xspace.client.xform.XImage.xeditorXImageNofloat": "مركز",
    "xspace.client.xform.XImage.xeditorXImageReplaceImage": "استبدال الصور",
    "xspace.client.xform.XImage.xeditorXImageRestoreWidth": "استعادة الأصلي حجم",
    "xspace.client.xform.XImage.xeditorXImageRightAlign": "تعويم إلى اليمين",
    "xspace.client.xform.dateRange.xformDefaultEndDatePlaceholder": "نهاية التاريخ",
    "xspace.client.xform.dateRange.xformDefaultStartDatePlaceholder": "بدء التسجيل",
    "xspace.client.xform.index.xformDefaultSubmitButtonLabel": "تقديم",
    "xspace.client.xform.index.xformUploaderErrorStatusCheckMessage": "لديك الصور أو ملفات في تحميل حالة الخطأ ، يرجى تقديم بعد المحاولة.",
    "xspace.client.xform.index.xformUploaderImageFileCheckMessage": "تحميل ليست الصورة الملفات ، يرجى إعادة تحميل الصور",
    "xspace.client.xform.index.xformUploaderUploadingStatusCheckMessage": "لديك الصور أو ملفات في تحميل الوضع ، يرجى تقديم لاحقا.",
    "xspace.client.xform.insertbar.xeditorInsertbarMenuTitle": "إدراج",
    "xspace.client.xform.insertbar.xeditorInsertbarTool": "أدوات",
    "xspace.client.xform.multiSelect.xformCheckAllLabel": "تحقق جميع",
    "xspace.client.xform.upload.xformBatchUploadDefaultLabel": "تحميل",
    "xspace.client.xform.upload.xformBatchUploadToolTip": "الصحافة Ctrl/الأوامر ل دفعة تحميل الملفات",
    "xspace.client.xform.upload.xformExampleImageLabel": "المثال صورة",
    "xspace.client.xform.upload.xformFileTemplateLabel": "قالب",
    "xspace.client.xform.upload.xformMaxFileNumErrorTip": "و تحميلها ملف يتجاوز الحد الأقصى",
    "xspace.client.xform.upload.xformMaxFileSizeErrorTip": "ماكس تحميل ملف حجم:",
    "xspace.client.xform.upload.xformUploadErrorTip": "تحميل فشل ، يرجى محاولة أخرى لاحقا."
};